export default {"productCard":"rvOTO","image--leading":"tH4RJ","image--trailing":"rTzfo","imageContainer":"sN42U","textContainer":"_0CQJU","title":"Ggxj5"};